import { ListRow } from './list_row.model';
import { Element } from './element.model';

export class List {
    // element: Element;
    rows: ListRow[] = [];
    rows_filtered: ListRow[] = [];
    // SEARCH
    search_str = '';
    search_columns: string[] = [];
    // SORT
    sort_columns: {} = {};
    // FILTER
    // filter: boolean = false;
    // filters = new UntypedFormGroup({});
    // show_filter: boolean = false;
    // PAGINATION
    page_number: number = 1;
    nb_by_page: number;
    nb_by_page_default: number = 25;
    page_interval: number[] = [];

    constructor(rows: ListRow[], element: Element) {
        // this.element = element;
        //   console.log(rows, element);
        // PARAMS
        this.nb_by_page = element.pagination === 0 ? 0 : (element.pagination ?? this.nb_by_page_default);
        // FILTERS
        Object.keys(element.details).forEach(key => {
            Object.keys(element.details[key]).forEach(subkey => {
                if (element.details[key][subkey].filter_search) {
                    this.search_columns.push(element.details[key][subkey]);
                }
            });
        });
        // ROWS
        rows?.forEach(row => {
            this.addRow(row, element);
        });
    }

    /** --------------------------------------------------------------------------------------------------------------- */

    nbPages() {
        return Math.ceil(this.rows_filtered.length / this.nbByPageTraduction());
    }
    firstAndLastElement() {
        return [(this.nbPages() - 1) * this.nbByPageTraduction()];
    }
    nbByPageTraduction() {
        return this.nb_by_page > 0 ? this.nb_by_page : this.rows_filtered.length;
    }
    updateNbByPage(nb: number) {
        this.nb_by_page = nb;
        this.updatePageInterval(true);
    }
    updatePageNumber(nb: number) {
        this.page_number = nb;
        this.updatePageInterval();
    }
    updatePageInterval(from_nbByPage: boolean = false) {
        this.page_interval = [];
        for (let i = this.page_number - (this.page_number > this.nbPages() - 2 ? 3 - (this.nbPages() - this.page_number) : 1); i < this.page_number + (this.page_number < 4 ? 5 - this.page_number : 2); i++) {
            if (i < 2 || i >= this.nbPages()) {
                continue;
            }
            this.page_interval.push(i);
        }
        // CHECK PAGE vs NUMBER OF PAGE
        if (!this.page_number) {
            this.page_number = 1;
        } else if (this.page_number > this.nbPages()) {
            this.page_number = from_nbByPage ? this.nbPages() : 1;
        }
    }

    /** --------------------------------------------------------------------------------------------------------------- */

    addRow(row, element: Element, for_construct: boolean = true) {
        let r = new ListRow(row, this, element);
        this.rows.push(r);
        if (for_construct) {
            this.rows_filtered.push(r);
        }
    }

    removeRow(row_id: string) {
        const index = this.rows.findIndex(row => row.ressource_id === row_id);
        if (index !== -1) {
            this.rows.splice(index, 1);
            this.rows_filtered.splice(
                this.rows_filtered.findIndex(row => row.ressource_id === row_id),
                1,
            );
        }
    }

    updateRow(row_updated, element: Element) {
        const index = this.rows.findIndex(row => row?.ressource_id === row_updated.entity_id);
        this.rows[index].update(row_updated, this, element);
    }
}
